module.exports = __webpack_public_path__ + "img/39600.3b614e38.jpg";